import { L as p } from "./like-anchor-1p1kOy4b.js";
import { F as u } from "./focusable-2cSgEeBs.js";
import { O as d } from "./observe-slot-text-DWmBsDhw.js";
import { i as m, x as i } from "./lit-element-6iugfgmM.js";
import { i as b } from "./query-D8_rwLua.js";
import { n as h } from "./property-BWlAHqg_.js";
const f = m`
    :host{vertical-align:top;--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-100);--spectrum-icon-size:var(--spectrum-workflow-icon-size-100);display:inline-flex}:host([dir]){-webkit-appearance:none}:host([disabled]){pointer-events:none;cursor:auto}#button{position:absolute;inset:0}::slotted(sp-overlay),::slotted(sp-tooltip){position:absolute}:host:after{pointer-events:none}::slotted(*){pointer-events:none}slot[name=icon]::slotted(svg),slot[name=icon]::slotted(img){fill:currentColor;stroke:currentColor;block-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100));inline-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100))}[icon-only]+#label{display:contents}:host([size=xs]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-50);--spectrum-icon-size:var(--spectrum-workflow-icon-size-50)}:host([size=s]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-75);--spectrum-icon-size:var(--spectrum-workflow-icon-size-75)}:host([size=l]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-200);--spectrum-icon-size:var(--spectrum-workflow-icon-size-200)}:host([size=xl]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-300);--spectrum-icon-size:var(--spectrum-workflow-icon-size-300)}:host([size=xxl]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-400);--spectrum-icon-size:var(--spectrum-workflow-icon-size-400)}
`;
var v = Object.defineProperty, a = (o, t, e, r) => {
  for (var l, s = void 0, n = o.length - 1; n >= 0; n--) (l = o[n]) && (s = l(t, e, s) || s);
  return s && v(t, e, s), s;
};
class c extends d(p(u), "", ["sp-overlay,sp-tooltip"]) {
  constructor() {
    super(), this.active = !1, this.type = "button", this.proxyFocus = this.proxyFocus.bind(this), this.addEventListener("click", this.handleClickCapture, { capture: !0 });
  }
  static get styles() {
    return [f];
  }
  get focusElement() {
    return this;
  }
  get hasLabel() {
    return this.slotHasContent;
  }
  get buttonContent() {
    return [i`
                <slot name="icon" ?icon-only=${!this.hasLabel}></slot>
            `, i`
                <span id="label">
                    <slot @slotchange=${this.manageTextObservedSlot}></slot>
                </span>
            `];
  }
  handleClickCapture(t) {
    if (this.disabled) return t.preventDefault(), t.stopImmediatePropagation(), t.stopPropagation(), !1;
    this.shouldProxyClick(t);
  }
  proxyFocus() {
    this.focus();
  }
  shouldProxyClick(t) {
    let e = !1;
    if (t && (t.metaKey || t.ctrlKey || t.shiftKey || t.altKey)) return !1;
    if (this.anchorElement) this.anchorElement.click(), e = !0;
    else if (this.type !== "button") {
      const r = document.createElement("button");
      r.type = this.type, this.insertAdjacentElement("afterend", r), r.click(), r.remove(), e = !0;
    }
    return e;
  }
  renderAnchor() {
    return i`
            ${this.buttonContent}
            ${super.renderAnchor({ id: "button", ariaHidden: !0, className: "button anchor", tabindex: -1 })}
        `;
  }
  renderButton() {
    return i`
            ${this.buttonContent}
        `;
  }
  render() {
    return this.href && this.href.length > 0 ? this.renderAnchor() : this.renderButton();
  }
  handleKeydown(t) {
    const { code: e } = t;
    e === "Space" && (t.preventDefault(), this.href === void 0 && (this.addEventListener("keyup", this.handleKeyup), this.active = !0));
  }
  handleKeypress(t) {
    const { code: e } = t;
    switch (e) {
      case "Enter":
      case "NumpadEnter":
        this.click();
    }
  }
  handleKeyup(t) {
    const { code: e } = t;
    e === "Space" && (this.removeEventListener("keyup", this.handleKeyup), this.active = !1, this.click());
  }
  manageAnchor() {
    this.href && this.href.length > 0 ? (!this.hasAttribute("role") || this.getAttribute("role") === "button") && this.setAttribute("role", "link") : (!this.hasAttribute("role") || this.getAttribute("role") === "link") && this.setAttribute("role", "button");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0"), t.has("label") && (this.label ? this.setAttribute("aria-label", this.label) : this.removeAttribute("aria-label")), this.manageAnchor(), this.addEventListener("keydown", this.handleKeydown), this.addEventListener("keypress", this.handleKeypress);
  }
  updated(t) {
    super.updated(t), t.has("href") && this.manageAnchor(), this.anchorElement && (this.anchorElement.tabIndex = -1, this.anchorElement.hasAttribute("aria-hidden") || this.anchorElement.setAttribute("aria-hidden", "true"), this.anchorElement.addEventListener("focus", this.proxyFocus));
  }
  update(t) {
    super.update(t), t.has("label") && (this.label ? this.setAttribute("aria-label", this.label) : this.removeAttribute("aria-label"));
  }
}
a([h({ type: Boolean, reflect: !0 })], c.prototype, "active"), a([h({ type: String })], c.prototype, "type"), a([b(".anchor")], c.prototype, "anchorElement");
export {
  c as B
};
//# sourceMappingURL=ButtonBase-DjzaXYmo.js.map
